import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import pt from './translations/pt.json';

i18n.use(initReactI18next).init({
  resources: {
    pt: { translation: { ...pt } },
  },
  lng: 'pt', // força sempre PT
  supportedLngs: ['pt'],
  fallbackLng: 'pt',
  interpolation: {
    escapeValue: false
  },
  debug: false
});
